import { posAxiosClient } from '@kinderlabs-pos/apis/axios';
import { BaseInfoType, ProductInfoType } from '@kinderlabs-pos/shared-data-type';

export const getStockManagedProductInfoListAsync = (rootUrl: string) => async () =>
	(await posAxiosClient.get<(ProductInfoType & BaseInfoType)[]>(`${rootUrl}/product/list/managed`))
		.data;
